import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

import { isMyTasksEnabledForOrg } from '@/constants/feature-flags';
import { buildOrgRoutePath, removeOrgPrefix } from '@/utils/routes';

/**
 * Lets /org-{id}/my-tasks render only for orgs in REACT_APP_TASKS_ENABLED_ORG_IDS;
 * any other org is sent to its landing page. The allowlist is a build-time
 * constant, so there is no loading state to wait for.
 */
export function MyTasksRouteValidator() {
  const { orgId } = useParams<{ orgId?: string }>();
  const organizationId = orgId ? removeOrgPrefix(orgId) : '';

  if (!isMyTasksEnabledForOrg(organizationId)) {
    return <Navigate to={organizationId ? buildOrgRoutePath('', organizationId) : '/'} replace />;
  }
  return <Outlet />;
}
